import {ValidationRuleFactory} from './factory';

export const v = new ValidationRuleFactory();
